// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Qjd5","additionalInfo":"AgreementModal_additionalInfo__3us0t"};